import { NotaListSearchComponent } from './NotaListSearchComponent'

export const NotaListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <NotaListSearchComponent />
  </div>
)
